import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enLogin from './locales/en/login.json';
import enPublicPage from './locales/en/publicPage.json';
import enDashboard from './locales/en/dashboard.json';
import enPrivacy from './locales/en/privacy.json';
import enTerms from './locales/en/terms.json';
import enEvents from './locales/en/events.json';

import zhCommon from './locales/zh-CN/common.json';
import zhLogin from './locales/zh-CN/login.json';
import zhPublicPage from './locales/zh-CN/publicPage.json';
import zhDashboard from './locales/zh-CN/dashboard.json';
import zhPrivacy from './locales/zh-CN/privacy.json';
import zhTerms from './locales/zh-CN/terms.json';
import zhEvents from './locales/zh-CN/events.json';

const resources = {
  en: {
    common: enCommon,
    login: enLogin,
    publicPage: enPublicPage,
    dashboard: enDashboard,
    privacy: enPrivacy,
    terms: enTerms,
    events: enEvents,
  },
  'zh-CN': {
    common: zhCommon,
    login: zhLogin,
    publicPage: zhPublicPage,
    dashboard: zhDashboard,
    privacy: zhPrivacy,
    terms: zhTerms,
    events: zhEvents,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'login', 'publicPage', 'dashboard', 'privacy', 'terms', 'events'],

    // React specific options
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
  });

export default i18n;
